import { IGetState, TBoardId } from '../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IChatDashboardSettings } from '../../../../../store/model/chatDashboardSettings/types';
import { updateAction } from '../../../../../store/model/chatDashboardSettings/actions/updateAction';
import { chatDashboardSettingsActionSet } from '../../../../../store/model/chatDashboardsSettings/actions/chatDashboardSettingsActionSet';
import { getRest } from '../getRest';
import { chatDashboardsSettingsActionSet } from 'app/store/model/actions/chatDashboardsSettingsActionSet';

export const loadChatDashboardSettings = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return dispatch(getRest(boardId))
            .then((notifications: IChatDashboardSettings) => {
                dispatch(chatDashboardsSettingsActionSet(chatDashboardSettingsActionSet(boardId, updateAction(notifications))));
                return notifications;
            });
    };
    return action;
};
